<div class="container-fluid">
  @if (isLoading) {
<loader [config]="{
    fullScreen: false,
    overlay: true,
    type: 'spinner',
    size: 'md',
    text: 'Loading...'
  }"/>
  }

  <div class="row">
    @if (canUploadCertificates) {
    <div class="col-md-4">
      <div class="card h-auto">
        <div class="card-header bg-light">
          <h4 class="card-title">Upload New Report</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="uploadForm">
            <div class="mb-3">
              <div class="custom-file-upload">
                <label for="primaryCertificateFile" class="btn btn-outline-primary w-100">
                  <i class="fa fa-file me-2"></i>Choose File
                </label>
                @if (selectedPrimaryFile) {
                  <div class="selected-file mt-3">
                    <span>Selected: <strong>{{ selectedPrimaryFile.name }}</strong></span>
                  </div>
                }
                @if (!selectedPrimaryFile) {
                  <div class="selected-file mt-3">
                    <span>No file selected</span>
                  </div>
                }
                <input
                  type="file"
                  class="d-none"
                  id="primaryCertificateFile"
                  (change)="onFileSelected($event, 'primary')">
              </div>
            </div>
            <div class="mb-3">
              <div class="custom-file-upload">
                <label for="secondaryCertificateFile" class="btn btn-outline-primary w-100">
                  <i class="fa fa-file me-2"></i>Choose Hash Code
                </label>
                @if (selectedHashCodeFile) {
                  <div class="selected-file mt-3">
                    <span>Selected: <strong>{{ selectedHashCodeFile.name }}</strong></span>
                  </div>
                }
                @if (!selectedHashCodeFile) {
                  <div class="selected-file mt-3">
                    <span>No file selected</span>
                  </div>
                }
                <input
                  type="file"
                  class="d-none"
                  id="secondaryCertificateFile"
                  (change)="onFileSelected($event, 'secondary')">
              </div>
            </div>
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-success"
                [disabled]="!selectedPrimaryFile && !selectedHashCodeFile"
                (click)="uploadCertificates()">
                <i class="fa fa-upload me-2"></i>Upload Reports
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    }

    <div [class]="canUploadCertificates ? 'col-md-8' : 'col-12'">
      <div class="card h-100">
        <div class="card-header bg-light">
          <h4 class="card-title">Active Reports</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Report Name</th>
                  <th>Description</th>
                  @if (canManageActive) {
                    <th class="text-center">Active</th>
                  }
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (activeCertificateRows.length > 0) {
                  @for (row of activeCertificateRows; track row) {
                    <tr class="certificate-row">
                      <td>
                        <div class="d-flex align-items-start">
                          <div class="cert-icons">
                            @if (row.source.active !== false) {
                              <i class="bi bi-check-circle-fill text-success me-1" title="Active"></i>
                            }
                            <i class="fa fa-file-pdf-o text-primary"></i>
                          </div>
                          <div class="cell-stack flex-grow-1">
                            <div class="stack-item">
                              {{ row.certificateAttachment?.fileNameOriginal || 'Unknown' }}
                            </div>
                            @for (hash of row.hashAttachments; track hash) {
                              <div class="stack-item">
                                <div class="d-flex align-items-center w-100">
                                  <span class="text-muted">{{ hash?.fileNameOriginal || 'Unknown' }}</span>
                                  <button class="btn btn-outline-primary btn-sm ms-2"
                                    (click)="downloadAttachment(hash)"
                                    title="Download Hash">
                                    <i class="fa fa-solid fa-download"></i>
                                  </button>
                                </div>
                              </div>
                            }
                            @if (row.source.createTime) {
                              <div class="stack-item">
                                <p class="text-muted small mb-0">
                                  {{ formatCreateTime(row.source.createTime) }}
                                </p>
                              </div>
                            }
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="cell-stack">
                          <div class="stack-item">
                            @if (row.source.description) {
                              <span>{{ row.source.description }}</span>
                            } @else {
                              <span class="text-muted">-</span>
                            }
                          </div>
                        </div>
                      </td>
                      @if (canManageActive) {
                        <td class="text-center">
                          <div class="form-check form-switch d-inline-block" title="Toggle Active">
                            <input class="form-check-input" type="checkbox"
                              role="switch"
                              [checked]="row.source.active !== false"
                              (change)="onToggleActive(row)">
                          </div>
                        </td>
                      }
                      <td class="text-center">
                        <div class="cell-stack align-items-center">
                          <div class="stack-item">
                            <div class="d-flex justify-content-center align-items-center">
                              <button class="btn btn-outline-primary btn-sm me-2"
                                (click)="downloadAttachment(row.certificateAttachment)"
                                title="Download Report">
                                <i class="fa fa-solid fa-download"></i>
                              </button>
                              @if (canManageCertificateRow) {
                                <button class="btn btn-outline-warning btn-sm me-2"
                                  (click)="openCommentModal(row.source, commentModal)"
                                  title="Add Comment">
                                  <i class="fa fa-solid fa-comment"></i>
                                </button>
                                <button class="btn btn-outline-danger btn-sm"
                                  (click)="deleteCertificate(row.source)"
                                  title="Delete Report">
                                  <i class="fa fa-solid fa-trash"></i>
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="canManageActive ? 4 : 3" class="text-center">No reports available</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (showInactiveTable) {
            <h5 class="mt-4">Inactive Reports</h5>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Report Name</th>
                    <th>Description</th>
                    @if (canManageActive) {
                      <th class="text-center">Active</th>
                    }
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @if (inactiveCertificateRows.length > 0) {
                    @for (row of inactiveCertificateRows; track row) {
                      <tr class="certificate-row">
                        <td>
                          <div class="d-flex align-items-start">
                            <div class="cert-icons">
                              <i class="fa fa-file-pdf-o text-primary"></i>
                            </div>
                            <div class="cell-stack flex-grow-1">
                              <div class="stack-item">
                                {{ row.certificateAttachment?.fileNameOriginal || 'Unknown' }}
                              </div>
                              @for (hash of row.hashAttachments; track hash) {
                                <div class="stack-item">
                                  <div class="d-flex align-items-center w-100">
                                    <span class="text-muted">{{ hash?.fileNameOriginal || 'Unknown' }}</span>
                                    <button class="btn btn-outline-primary btn-sm ms-2"
                                      (click)="downloadAttachment(hash)"
                                      title="Download Hash">
                                      <i class="fa fa-solid fa-download"></i>
                                    </button>
                                  </div>
                                </div>
                              }
                              @if (row.source.createTime) {
                                <div class="stack-item">
                                  <p class="text-muted small mb-0">
                                    {{ formatCreateTime(row.source.createTime) }}
                                  </p>
                                </div>
                              }
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="cell-stack">
                            <div class="stack-item">
                              @if (row.source.description) {
                                <span>{{ row.source.description }}</span>
                              } @else {
                                <span class="text-muted">-</span>
                              }
                            </div>
                          </div>
                        </td>
                        @if (canManageActive) {
                          <td class="text-center">
                            <div class="form-check form-switch d-inline-block" title="Toggle Active">
                              <input class="form-check-input" type="checkbox"
                                role="switch"
                                [checked]="row.source.active !== false"
                                (change)="onToggleActive(row)">
                            </div>
                          </td>
                        }
                        <td class="text-center">
                          <div class="cell-stack align-items-center">
                            <div class="stack-item">
                              <div class="d-flex justify-content-center align-items-center">
                                <button class="btn btn-outline-primary btn-sm me-2"
                                  (click)="downloadAttachment(row.certificateAttachment)"
                                  title="Download Report">
                                  <i class="fa fa-solid fa-download"></i>
                                </button>
                                @if (canManageCertificateRow) {
                                  <button class="btn btn-outline-warning btn-sm me-2"
                                    (click)="openCommentModal(row.source, commentModal)"
                                    title="Add Comment">
                                    <i class="fa fa-solid fa-comment"></i>
                                  </button>
                                  <button class="btn btn-outline-danger btn-sm"
                                    (click)="deleteCertificate(row.source)"
                                    title="Delete Report">
                                    <i class="fa fa-solid fa-trash"></i>
                                  </button>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  } @else {
                    <tr>
                      <td [attr.colspan]="canManageActive ? 4 : 3" class="text-center">No inactive reports</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #commentModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Description</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="commentForm">
      <div class="mb-3">
        <label for="comment" class="form-label">Description</label>
        <textarea
          class="form-control"
          formControlName="comment"
          rows="4"
          placeholder="Enter your description here..."
        ></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!commentForm.valid" (click)="saveComment()">Save</button>
  </div>
</ng-template>
